import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, withStateHandlers } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Clearfix,
  Glyphicon,
} from 'react-bootstrap';

import { finalizePayPeriod } from '../actions';

/* TODO: Refactor to use a factory */
const buttonClickPropTypes = {
  isClicked: PropTypes.bool.isRequired,
  setClicked: PropTypes.func.isRequired,
  clearClicked: PropTypes.func.isRequired,
};

const withButtonState = withStateHandlers(
  (props) => { return { isClicked: false }; },
  {
    setClicked: (state, props) => {
      return () => { return { isClicked: true }; };
    },
    clearClicked: (state, props) => {
      return () => { return { isClicked: false }; };
    },
  },
);

const propTypes = exact({
  payPeriod: PropTypes.object.isRequired,
  isPayPeriodFinalized: PropTypes.bool.isRequired,
  finalizePayPeriodAction: PropTypes.func.isRequired,
  ...buttonClickPropTypes,
});

const FinalizePayPeriod = (props) => {
  const {
    payPeriod,
    isPayPeriodFinalized,
    finalizePayPeriodAction,
  } = props;
  const payPeriodId = payPeriod.id;


  const { isClicked, setClicked, clearClicked } = props;
  const renderMessage = () => {
    return (
      <p className="pull-left">
        Step 2: After successfully exporting into payroll, finalize the pay period:
      </p>
    );
  };

  const handleFinalizePayPeriod = async (paramPayPeriodId) => {
    try {
      setClicked();
      await finalizePayPeriodAction(paramPayPeriodId);
    } finally {
      clearClicked();
    }
  };

  return (
    <Clearfix>
      {!isPayPeriodFinalized && renderMessage()}
      <ButtonToolbar className="pull-right">
        <Button
          disabled={isPayPeriodFinalized || isClicked}
          onClick={() => { handleFinalizePayPeriod(payPeriodId); }}
        >
          <Glyphicon glyph="envelope" style={{ marginRight: '0.5em' }} />
          Finalize Pay period
        </Button>
      </ButtonToolbar>
    </Clearfix>
  );
};

FinalizePayPeriod.propTypes = propTypes;

const mapDispatchToProps = {
  finalizePayPeriodAction: finalizePayPeriod,
};

const withRedux = connect(null, mapDispatchToProps);
const enhance = compose(
  withRedux,
  withButtonState,
);
export default enhance(FinalizePayPeriod);
